module.exports = __webpack_public_path__ + "img/question.337d9c0a.svg";